import { Rethink_Sans } from 'next/font/google';
import localFont from 'next/font/local';

// Chargement des polices (locales et via Google Fonts)
// Chaque police doit être assignée à une variable dédiée
// -> Il s'agit d'un pré-requis de Next.js pour les polices
const FONT_ARTZ = localFont({
  src: './Artz/Artz-Regular.woff2',
  fallback: ['Arial Narrow', 'Arial', 'sans-serif'],
  variable: '--font-artz',
  display: 'swap',
  preload: true,
  weight: '700',
  style: 'normal',
});
const FONT_ICONS = localFont({
  src: './MM-Icons/font-icons-mm.woff2',
  variable: '--font-icons',
  display: 'block',
  preload: true,
});
const FONT_RETHINK = Rethink_Sans({
  adjustFontFallback: false, // https://github.com/vercel/next.js/issues/47115
  fallback: ['Arial', 'sans-serif'],
  variable: '--font-rethink',
  display: 'swap',
  preload: true,
  subsets: ['latin'],
  weight: 'variable',
  style: ['normal', 'italic'],
});

// Pour injection dans le CSS global
export const CSS_FONTS = `
  :root {
    --font-artz: ${FONT_ARTZ.style.fontFamily};
    --font-icons: ${FONT_ICONS.style.fontFamily};
    --font-rethink: ${FONT_RETHINK.style.fontFamily};
  }
  body {
    font-family: var(--font-rethink);
  }
`;
